/*
  Produktseite: grosse Galeriebilder vorladen, damit der Wechsel per Vorschaubild sofort geht.

  Gemessen am 2026-09-14 (Hybrid Hexa, M-Test): Der erste Klick auf ein Vorschaubild dauerte
  0,9-1,3 s, fast alles davon Wartezeit auf den Shopify-Bildserver (die Groesse wird beim
  ersten Abruf erst erzeugt). Der zweite Klick auf dasselbe Bild: 0 ms. Also vorher holen.

  - Nach dem Laden der Seite, in Leerlaufzeit, der Reihe nach alle sichtbaren Vorschaubilder
    (zwei gleichzeitig, damit das Hauptbild und der Rest der Seite nicht ausgebremst werden).
  - Beim Zeigen/Fokussieren/Beruehren eines Vorschaubilds dieses sofort (vor der Warteschlange).
  - Mit „Datensparmodus" (Save-Data) oder langsamer Verbindung nur auf Zeigen, nicht im Hintergrund.
  Geladen wird mit denselben srcset/sizes wie das Hauptbild — der Browser waehlt also genau die
  Datei, die er beim Klick anzeigt, und findet sie dann im Cache.
*/
(() => {
  var haupt = document.getElementById('pdp-main-img');
  var reihe = document.getElementById('pdp-thumbs');
  if (!haupt || !reihe) return;

  var geladen = {};
  var warteschlange = [];
  var aktiv = 0;
  var PARALLEL = 2;

  function schluessel(btn) {
    return btn.getAttribute('data-srcset') || btn.getAttribute('data-src') || '';
  }

  function laden(btn, danach) {
    var k = schluessel(btn);
    if (!k || geladen[k]) {
      if (danach) danach();
      return;
    }
    geladen[k] = true;
    var img = new Image();
    img.decoding = 'async';
    img.sizes = haupt.getAttribute('sizes') || '100vw';
    if (btn.getAttribute('data-srcset')) img.srcset = btn.getAttribute('data-srcset');
    img.onload = img.onerror = () => {
      if (danach) danach();
    };
    img.src = btn.getAttribute('data-src');
  }

  function weiter() {
    var btn;
    while (aktiv < PARALLEL && warteschlange.length) {
      btn = warteschlange.shift();
      if (btn.hidden || geladen[schluessel(btn)]) continue;
      aktiv++;
      laden(btn, () => {
        aktiv--;
        weiter();
      });
    }
  }

  function sparen() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }

  // Sofort beim Zeigen, Fokussieren oder Beruehren
  ['pointerenter', 'focusin', 'touchstart'].forEach((ev) => {
    reihe.addEventListener(
      ev,
      (e) => {
        var btn = e.target?.closest ? e.target.closest('.pdp__thumb') : null;
        if (btn) laden(btn);
      },
      { passive: true, capture: ev === 'pointerenter' },
    );
  });

  if (sparen()) return;

  function start() {
    warteschlange = [].slice.call(reihe.querySelectorAll('.pdp__thumb'));
    weiter();
  }
  function wennRuhig() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 2000 });
    else window.setTimeout(start, 300);
  }
  if (document.readyState === 'complete') wennRuhig();
  else window.addEventListener('load', wennRuhig, { once: true });
  // Farbwechsel blendet andere Vorschaubilder ein (filterGallery) — die dann ebenfalls holen.
  // Bereits geladene werden uebersprungen, der Rest kommt in die Warteschlange.
  document.addEventListener('fennext:variant', () => {
    window.setTimeout(start, 50);
  });
})();
